import { TranslationService } from '@alliance/shared/translation'
import { selectSlice } from '@rx-angular/state/selections'
import { RxStateComponent } from '@alliance/shared/models'
import { Component, ChangeDetectionStrategy, forwardRef, Input } from '@angular/core'
import { OnboardingCategoriesEnum } from '../../../../domain/models/onboarding-categories.enum'
import { VisibilityStateService } from '../../../../api'
import { Translations } from '../../localization/translations'
import { IconArrowsVerticalDropdown20 } from '@alliance/shared/icons'
import { CategoriesDataValuesEnum } from '../../models/categories-data-values.enum'
import { SLIDE_TO_IMAGE_MAP } from '../../constants/slide-to-image-map'
import { NgxSiemaSlideComponent } from '@alliance/shared/carousel-gallery'
import { AtsGtmEvent, OnboardingSlideViewEvent } from '@alliance/ats/analytics/utils'
import { asyncScheduler, map, switchMap, timer } from 'rxjs'

@Component({
  selector: 'lib-slide-template',
  templateUrl: './slide-template.component.html',
  providers: [{ provide: NgxSiemaSlideComponent, useExisting: forwardRef(() => SlideTemplateComponent) }],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlideTemplateComponent extends RxStateComponent<{
  activeCategory: OnboardingCategoriesEnum | null
  categoryData: CategoriesDataValuesEnum | null
  eventData: AtsGtmEvent<string | null> | null
}> {
  public readonly SLIDE_TO_IMAGE_MAP = SLIDE_TO_IMAGE_MAP
  public readonly ICONS = { IconArrowsVerticalDropdown20 }
  public readonly state = this.connectViewState(['activeCategory', 'categoryData', 'eventData'])
  public constructor(public translations: Translations, private visibilityStateService: VisibilityStateService, private translationService: TranslationService) {
    super()
    this.initState({
      activeCategory: this.visibilityStateService.select('activeCategory'),
      categoryData: null,
      eventData: this.$.pipe(
        selectSlice(['activeCategory', 'categoryData']),
        switchMap(({ activeCategory, categoryData }) => timer(0, asyncScheduler).pipe(map(() => this.getAnalyticsEvent(activeCategory, categoryData))))
      )
    })
  }

  @Input() public set categoryData(categoryData: CategoriesDataValuesEnum) {
    this.set({ categoryData })
  }
  public backToList(): void {
    this.visibilityStateService.setActiveCategory(null)
  }

  private getAnalyticsEvent(activeCategory: OnboardingCategoriesEnum | null, categoryData: CategoriesDataValuesEnum | null): AtsGtmEvent<string | null> | null {
    if (!activeCategory || !categoryData) {
      return null
    }
    const categoryTranslation = this.translationService.translate(this.translations.categories[activeCategory]).trim()
    const dataTranslation = this.translationService.translate(this.translations.headings[categoryData]).trim()
    return {
      event: OnboardingSlideViewEvent,
      labelParam: `${categoryTranslation}_${dataTranslation}`
    }
  }
}
